import { createContext, useContext } from "react";
import { TWebsiteBuilderTreeRefMap } from "./hooks/treeRefMap/useTreeRefMapRegistration";
import { IWebsiteBuilderElementOperations } from "./hooks/elementOperations/useWebsiteBuilderElementOperations";
import { IWebsiteBuilderClipboard } from "./hooks/clipboard/useWebsiteBuilderClipboard";
import { IWebsiteBuilderSectionOperations } from "./hooks/sectionOperations/useWebsiteBuilderSectionOperations";
import { IWebsiteBuilderDesignSpaceBoundaries, TWebsiteBuilderScrollContainerRef } from "./WebsiteBuilderEditor";

interface IWebsiteBuilderContext {
  treeRefMap: TWebsiteBuilderTreeRefMap;
  elementOperations: IWebsiteBuilderElementOperations;
  sectionOperations: IWebsiteBuilderSectionOperations;
  clipboard: IWebsiteBuilderClipboard;
  designSpaceBoundaries: IWebsiteBuilderDesignSpaceBoundaries;
  scrollContainerRef: TWebsiteBuilderScrollContainerRef;
}

const defaultWebsiteBuilderContext: IWebsiteBuilderContext = {
  treeRefMap: null,
  elementOperations: null,
  sectionOperations: null,
  clipboard: null,
  designSpaceBoundaries: null,
  scrollContainerRef: null,
};

export const WebsiteBuilderContext = createContext<IWebsiteBuilderContext>(defaultWebsiteBuilderContext);
export const useWebsiteBuilderContext = () => useContext(WebsiteBuilderContext);
